export default __webpack_public_path__ + "3cb47312d73ba23c304ee73345f4fc66.svg";